import { ServiceStatusCode } from "../types";

type ClaimsLike = Partial<{
    admin: unknown;
    cr: unknown;
    oper: unknown;
}>;

export const PORTFOLIO_CR_PENDING_STATUSES: ServiceStatusCode[] = [
    ServiceStatusCode.waiting_for_kyc,
    ServiceStatusCode.review,
    ServiceStatusCode.approval,
];

export const PORTFOLIO_OPER_PENDING_STATUSES: ServiceStatusCode[] = [
    ServiceStatusCode.waiting_for_operations_approval,
];

export const getPortfolioPendingStatusesForClaims = (customClaims?: ClaimsLike): ServiceStatusCode[] => {
    const claims = customClaims ?? {};
    const statuses = new Set<ServiceStatusCode>();

    if (claims.admin || claims.cr) {
        PORTFOLIO_CR_PENDING_STATUSES.forEach((status) => statuses.add(status));
    }

    if (claims.admin || claims.oper) {
        PORTFOLIO_OPER_PENDING_STATUSES.forEach((status) => statuses.add(status));
    }

    return Array.from(statuses);
};
